import type { OrganizationResponse } from 'generatedTypes/user/models';

import { WithPopover, Wrapper } from '@american-autonomy/ag-ui';

import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import OrganizationDropdownMenuButton from 'components/OrganizationDropdownMenuButton';
import OrganizationDropdownMenuItem from 'components/OrganizationDropdownMenuItem';
import LogoutText from 'components/text/LogoutText';

import useGlobalStore from 'hooks/useGlobalStore';
import useLogout from 'hooks/useLogout';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OrganizationDropDown: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { LOG_OUT } = useTranslation();

    const { logout } = useLogout();

    const { getValue } = useGlobalStore({
        namespace: 'useOrganizations'
    });

    const currentOrganizations: OrganizationResponse[] = getValue('organizations');

    const currentOrganization = currentOrganizations[0];

    return (
        <WithPopover
            trigger={
                <OrganizationDropdownMenuButton
                    currentOrganizationName={currentOrganization.name}
                />
            }
            className={`${className} ${styles.organizationDropdown}`}
            testId={testId}>
            <Wrapper className={styles.wrapper}>
                {currentOrganizations.map(({ id, name }) => (
                    <OrganizationDropdownMenuItem key={id} value={name} />
                ))}
            </Wrapper>

            <DropdownMenuItemContainer
                className={styles.organizationDropdownMenuItemContainer}
                onClick={logout}>
                <LogoutText text={LOG_OUT} />
            </DropdownMenuItemContainer>
        </WithPopover>
    );
};

export default OrganizationDropDown;
